import { useState, useEffect } from 'react';
import { useZakeke } from 'zakeke-configurator-react';

const useCart = () => {
  const { isAddToCartLoading, price, currency, culture, addToCart } = useZakeke();
  const [formatPrice, setFormatPrice] = useState<string | null>(null);

  useEffect(() => {
    if (currency && culture) {
      const formatter = new Intl.NumberFormat(culture, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
      });
      const newValue = formatter.format(price);
      if (formatPrice !== newValue) {
        setFormatPrice(newValue);
      }
    }
  }, [currency, culture, price]);

  return {
    isLoading: isAddToCartLoading,
    add: addToCart,
    price: formatPrice,
    setPrice: (value: string) => setFormatPrice(value),
    rawPrice: price,
  };
};

export { useCart };
